import { IWidget } from 'core-components/sitebuilder/models/IWidget'

import { IMeasureSettings, TInitializationState } from './models/IMeasureController'

export class BaseMeasureController {
  constructor(
    widgetInfo: IWidget | string,
    { startInitializationMeasure, user }: IMeasureSettings
  ) {}

  public start = (state: TInitializationState, key: string = 'default') => {}
  public stop = (state: TInitializationState, key: string = 'default') => {}
  public clearFullMetric = () => {}
}
